import React from 'react';
import NextImage from 'next/image';

function ACImage({ placeholder = 'empty', ...props }) {
  return <NextImage alt="image" layout="fill" objectFit="cover" {...props} placeholder={placeholder} />;
}

export default ACImage;
